import { createClient } from "@supabase/supabase-js";
const SUPABASE_URL = "https://vhlvapimmiautphegmxa.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYyMDEyMDU5MSwiZXhwIjoxOTM1Njk2NTkxfQ.FAVjq1PoOfWGIsqAd_DxvspcPA0e7f9ZswLHUum2jvA";
export class UserService {
    constructor() {
        this.supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
    }
    static getInstance() {
        if (!UserService.instance) {
            UserService.instance = new UserService();
        }
        return UserService.instance;
    }
    onAuthStateChange(callback) {
        return this.supabase.auth.onAuthStateChange(callback);
    }
    currentUser() {
        return this.supabase.auth.user();
    }
    async signUp(email, password) {
        let { user, error } = await this.supabase.auth.signUp({ email, password });
        if (error)
            throw error;
    }
    async signIn(email, password) {
        let { user, error } = await this.supabase.auth.signIn({ email, password });
        if (error)
            throw error;
    }
    async signOut() {
        let { error } = await this.supabase.auth.signOut();
        if (error)
            throw error;
    }
}
